import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import "./VerifyEmail.css"
import { toast } from 'react-toastify'

const VerifyEmail = () => {
    const {token} = useParams()
  const navigate = useNavigate()

    const verifyEmail = async () => {
        // const urlParams = new URLSearchParams(window.location.search);
        if (token) {
        try {
          //https://riymay.com/api/v1/user/update/user-info/email/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NzU0NzcxNGI1MTRlY2FhMmQwZDNmNmUiLCJlbWFpbCI6Im11cmFsaW1hbnRoYTMxN0BnbWFpbC5jb20iLCJpYXQiOjE3Mzk4OTkwNjAsImV4cCI6MTczOTkwNjI2MH0.QZCYSTwsN4l2YZO7N1eGUvNH9boSarmPD2P3i_4arc0
            const response = await fetch(`https://riymay.com/api/v1/user/update/user-info/email/${token}`, {
            method: "GET",
            headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
            });

            
            if (!response.ok) {
              toast.error("❌ Failed to verify", {
                position: "top-right",
                autoClose: 5000, // Closes after 5 seconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
              });
                          // setUserData({ ...userData, email: data.newEmail });
            // setVerificationMessage("Email verified successfully!");
            } 
            const data = await response.json();
            toast.error(data.message || "An error occurred.", {
              position: "top-right",
              autoClose: 5000, // Closes after 5 seconds
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
            // setVerificationMessage(data.message || "Verification failed.");
          navigate("/newuserprofile", {state: {message: data.message}})
            
        } catch (error) {
            console.error("Error verifying email:", error);
        }
        }
    };
    
  return (
    <div className='email-button-container'>
      <p>Verify Your Email..!</p>
      <button className='email-button' onClick={verifyEmail}>Verify</button>

    </div>
  )
}

export default VerifyEmail
